import styled, { css } from 'styled-components';
import PreviewSpecs, { Icon, GridItem } from 'gatsby-theme-vehicles/src/components/preview/components/specs';

export default styled(PreviewSpecs)`
  margin-bottom: 1rem;

  ${({ $rowLayout }) => $rowLayout && css`
    display: flex;
    justify-content: flex-start;
  `}

  ${({ $columnLayout }) => $columnLayout && css`
    margin-left: -1rem;
    margin-right: -1rem;
  `}

  ${Icon} {
    width: 2.125rem;
    color: ${({ theme }) => theme.grayLightColor};
  }

  ${GridItem} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &:not(:last-of-type) {
      border-right: 1px solid ${({ theme }) => theme.grayLightColor};
    }

    ${({ $rowLayout }) => $rowLayout && css`
      padding-right: 1rem;
      padding-left: 1rem;
    `}

    span {
      padding-top: .25rem;
      font-size: 0.875rem;
    }
  }
`;
